import { Navigate } from "react-router-dom";

export default function LegacyLeaveTypesRedirect() {
  return <Navigate to="/requests?section=leave" replace />;
}
